/** Fetch ids used across multiple parts of the application(not just the sagas) **/

const FETCH_IDS = {
  DEVICE_MANAGEMENT_EXPERIENCE: {
    LISTEN_DEVICE: 'DeviceManagementExperienceSaga.listenDevice'
  }
}

export default FETCH_IDS
